import fetch from "../../utils/fetch";

class ServerFunctionsLog {
  constructor() {
    this.fetchExecutionLogs = this.fetchExecutionLogs.bind(this);
  }

  fetchExecutionLogs = async ({
    range: [startTime, endTime],
    token,
    batchMinSize,
    datasourceKey,
    identifier
  }) => {
    let fetchLogsUrl = `/api/datasource/${datasourceKey}/logs?startTime=${startTime}&endTime=${endTime}&batchMinSize=${batchMinSize}`;
    if (typeof identifier !== "undefined") {
      fetchLogsUrl += `&identifier=${identifier}`;
    }

      const res = await fetch(fetchLogsUrl, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { "x-logs-token": token } : {}),
        },
      });

      const resp = await res.json();
      if (res.status !== 200) {
        console.error(resp);
        throw new Error(resp.errorMessage);
      }

      return {
        logs: resp.result,
        nextToken: resp.nextToken,
      };
  };
}
export default ServerFunctionsLog;
